/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
} from './Message';

/**
 * 
 * @export
 * @interface ResponseMessage
 */
export interface ResponseMessage {
    /**
     * 
     * @type {boolean}
     * @memberof ResponseMessage
     */
    status: boolean;
    /**
     * 
     * @type {number}
     * @memberof ResponseMessage
     */
    statusCode: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseMessage
     */
    errorMessage?: string;
    /**
     * 
     * @type {Message}
     * @memberof ResponseMessage
     */
    data?: Message;
}

/**
 * Check if a given object implements the ResponseMessage interface.
 */
export function instanceOfResponseMessage(value: object): boolean {
    if (!('status' in value)) return false;
    if (!('statusCode' in value)) return false;
    return true;
}

export function ResponseMessageFromJSON(json: any): ResponseMessage {
    return ResponseMessageFromJSONTyped(json, false);
}

export function ResponseMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'statusCode': json['status_code'],
        'errorMessage': json['error_message'] == null ? undefined : json['error_message'],
        'data': json['data'] == null ? undefined : MessageFromJSON(json['data']),
    };
}

export function ResponseMessageToJSON(value?: ResponseMessage | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': value['status'],
        'status_code': value['statusCode'],
        'error_message': value['errorMessage'],
        'data': MessageToJSON(value['data']),
    };
}

